/* eslint-disable jira/filename-case */
export const getAliasesForField = (
	field: string,
	fieldToJqlTermMap: Map<string, string>,
): string[] => {
	// provided field could be a field id, name, an alias, or a jql term
	let term = fieldToJqlTermMap.get(field);
	if (term === undefined) {
		// it may be a jql term itself
		// filter is still an experiment feature in Iterator so we do old school looping
		for (const keyValuePair of fieldToJqlTermMap.entries()) {
			if (keyValuePair[1] === field) {
				term = keyValuePair[1];
				break;
			}
		}
	}
	if (term === undefined) {
		return [];
	}
	// we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
	const set = new Set<string>();
	set.add(term);

	for (const keyValuePair of fieldToJqlTermMap.entries()) {
		if (keyValuePair[1] === term) {
			set.add(keyValuePair[0]);
		}
	}
	return Array.from(set);
};
